import Rails from "@rails/ujs";
import '../src/stylesheets/simple/simple.scss';
import "bootstrap/dist/js/bootstrap";
import '../modules/rich_text_editor';
Rails.start();
